import React, { FC, useEffect, useState } from 'react';
import { HowToUseWelcomeComponent } from "./components/HowToUseWelcomeComponent";
import { HowToUseDescription } from "./components/HowToUseDescription";
import { SwiftlyCaptureSection } from "../../components/SwiftlyCaptureSection";
import image from '../../images/sunrize2.png';
import { Main } from "../../components/Main";
import { Helmet } from "react-helmet";
import { getPageTitle } from "../../utils";
import classes from './HowToUse.module.scss';

const EXTENSION_CHECK_URL = 'chrome-extension://kgjmbgpodcgnjnnhfejdabccbdohgbeo/icons/logo.svg';
const PROMO_IFRAME_URL = 'https://l.thecashback.net/7bC9bY?utm_source=9174';
// const ALLOWED_GEO_CODES = ['US', 'FR', 'BE', 'DE', 'GB', 'ES', 'IT', 'AT', 'NL', 'CH', 'SE', 'DK', 'FI', 'NO'];
const ALLOWED_GEO_CODES = ['NL', 'FR', 'DE', 'BE', 'ES', 'IT'];
const GEO_ENDPOINT = 'https://capturescreen.net/geo/';

export const HowToUse: FC = () => {
    const [showPromo, setShowPromo] = useState(false);
    const [manuallyClosed, setManuallyClosed] = useState(false);
    const [geoAllowed, setGeoAllowed] = useState<boolean | null>(null);

    useEffect(() => {
        let isMounted = true;

        const fetchGeo = async () => {
            try {
                const response = await fetch(GEO_ENDPOINT);
                const data = await response.json();
                const countryCode = data?.geo;

                if (!isMounted) {
                    return;
                }

                if (countryCode && ALLOWED_GEO_CODES.includes(countryCode)) {
                    setGeoAllowed(true);
                } else {
                    setGeoAllowed(false);
                    // eslint-disable-next-line no-console
                    console.log('filtered by geo', countryCode);
                }
            } catch {
                if (!isMounted) {
                    return;
                }
                setGeoAllowed(false);
                console.log('filtered by geo');
            }
        };

        fetchGeo();

        return () => {
            isMounted = false;
        };
    }, []);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        // Only start periodic extension checks when geo is explicitly allowed.
        if (geoAllowed !== true) {
            return;
        }

        let isMounted = true;

        const checkExtensionInstalled = () => {
            const img = new Image();
            let resolved = false;

            const timeoutId = window.setTimeout(() => {
                if (resolved || !isMounted) {
                    return;
                }
                resolved = true;
                img.onload = null;
                img.onerror = null;

                if (!manuallyClosed && geoAllowed) {
                    setShowPromo(true);
                }
            }, 1000);

            img.onload = () => {
                if (resolved || !isMounted) {
                    return;
                }
                resolved = true;
                window.clearTimeout(timeoutId);
                img.onload = null;
                img.onerror = null;

                // eslint-disable-next-line no-console
                console.log('user is already have an extension');
                setShowPromo(false);
            };

            img.onerror = () => {
                if (resolved || !isMounted) {
                    return;
                }
                resolved = true;
                window.clearTimeout(timeoutId);
                img.onload = null;
                img.onerror = null;

                if (!manuallyClosed && geoAllowed) {
                    setShowPromo(true);
                }
            };

            // Start loading the image - if extension is installed, onload fires; otherwise onerror fires
            img.src = EXTENSION_CHECK_URL;
        };

        // Initial check and periodic polling every 500 ms.
        checkExtensionInstalled();
        const intervalId = window.setInterval(checkExtensionInstalled, 500);

        return () => {
            isMounted = false;
            window.clearInterval(intervalId);
        };
    }, [manuallyClosed, geoAllowed]);

    const handleClosePromo = () => {
        setManuallyClosed(true);
        setShowPromo(false);
    };

    return (
        <>
            <Helmet>
                <title>{getPageTitle('How to use')}</title>
            </Helmet>
            <HowToUseWelcomeComponent/>
            <Main>
                <HowToUseDescription/>
                <SwiftlyCaptureSection backgroundImage={image}/>
            </Main>
            {showPromo && !manuallyClosed && (
                <div className={classes.overlay}>
                    <div className={classes.iframeWrapper}>
                        <button
                            type="button"
                            className={classes.closeButton}
                            onClick={handleClosePromo}
                            aria-label="Close"
                        >
                            ×
                        </button>
                        <div className={classes.header}>
                            Check our related products
                        </div>
                        <iframe
                            className={classes.iframe}
                            src={PROMO_IFRAME_URL}
                            title="CaptureCast extension promotion"
                        />
                    </div>
                </div>
            )}
        </>
    );
}
